/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/providers/apiService/api.service';
import * as moment from 'moment';
import { ToastService } from 'src/app/providers/toastService/toast.service';
import { AlertController, IonAccordionGroup, LoadingController, ModalController, NavController, PopoverController } from '@ionic/angular';
import { DoctorsListComponent } from 'src/app/components/doctors-list/doctors-list.component';
import { IonicSelectableComponent } from 'ionic-selectable';
import { StorageService } from 'src/app/providers/storageService/storage.service';
import { ItemListComponent } from 'src/app/components/item-list/item-list.component';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { AccessService } from 'src/app/providers/access/access.service';
@Component({
  selector: 'app-physician',
  templateUrl: './physician.page.html',
  styleUrls: ['./physician.page.scss'],
})
export class PhysicianPage implements OnInit {
  @ViewChild('serviceDateAccordion', { static: true }) serviceDateAccordion: IonAccordionGroup;
  @ViewChild('referralDateAccordion', { static: true }) referralDateAccordion: IonAccordionGroup;
  physicianForm: FormGroup;
  checkBoxs = [
    { itemNumber: 110, id: 1 },
    { itemNumber: 116, id: 2 },
    { itemNumber: 132, id: 3 },
    { itemNumber: 133, id: 4 },
    { itemNumber: 141, id: 5 },
    { itemNumber: 143, id: 6 },
  ];
  selectedArray: any = [];
  buttonDisabled = false;
  hospitalList: any;
  state$: Observable<object>;
  hospitalId: any;
  user: any;
  disableButton = false;
  data: any;
  img: any;
  referralDate: any;
  serviceDate: any;
  thisVersion:string;
  patientType: string;
  minDate = moment().format();

  errorMessages = {
    referringProviderF: [{ type: 'required', message: ' Enter Referring Provider First' }],
    referringProviderL: [{ type: 'required', message: ' Enter Referring Provider Last' }],
    referralDate: [{ type: 'required', message: ' Choose Referral Date' }],
    serviceDate: [{ type: 'required', message: ' Choose Service Date' }],
  };
  mbsValidateitems = [];

  constructor(
    public formbuilder: FormBuilder,
    public router: Router,
    private apiService: ApiService,
    public route: ActivatedRoute,
    public toastService: ToastService,
    public navCtrl: NavController,
    public modalController: ModalController,
    private popoverCtrl: PopoverController,
    private storageService: StorageService,
    private ngZone: NgZone, 
    public alertController: AlertController,
    private appVersion: AppVersion, 
    private loadingController: LoadingController,
    public accessService: AccessService,
  ) {

    
  this.appVersion.getVersionNumber().then((res)=>{
    this.thisVersion = res;
  });

    this.physicianForm = this.formbuilder.group({
      referringProviderF: ['', Validators.required],
      referringProviderL: ['', Validators.required],
      referringProvider: [''],
      referralDate: [moment().format(), Validators.required],
      hospital: [''],
      ward: [''],
      wardRound: [false],
      serviceDate: [moment().format(), Validators.required],
      itemListAdditional: [[]],
      comments: [''],
      itemList: [''],
      editing: [],
      submission_id: [],
      User: [],
      billType: ['physician'],
      ionicSelect: [[]], 
      version: this.thisVersion,
    });
    // this.getHospitalList();
    this.referralDate = moment().format();
    this.serviceDate = moment().format();
    this.editdata();
    this.getHospitalList();
  }

  ngOnInit() {
    this.serviceDate = moment().format();
    this.physicianForm.controls.serviceDate.setValue(this.serviceDate);
    this.storageService.get('state').then((data) => {
      //console.log('state data', data);
      this.patientType = data;
    });
  }

  ionViewDidEnter() {
    this.accessService.resetLogoutTimer();
  }

  editdata() {
    if (this.router.getCurrentNavigation().extras.state) {
      this.data = this.router.getCurrentNavigation().extras.state;
      //console.log('routeData:: ', this.data);
      this.hospitalId = this.data.Data.hospital;
      
      var refF = this.data.Data.referring_provider.split(" ")[0];
      this.physicianForm.controls.referringProviderF.setValue(refF);
      this.physicianForm.controls.referringProviderL.setValue(this.data.Data.referring_provider.replace(refF + " ",""));
      
      this.physicianForm.controls.referralDate.setValue(this.data.Data.referral_date);
      if (this.data.Data.referral_date)
      {
        this.referralDate = this.data.Data.referral_date;
      }
      this.physicianForm.controls.ward.setValue(this.data.Data.ward);
      this.physicianForm.controls.wardRound.setValue(this.data?.Data.admission_status);
      this.physicianForm.controls.serviceDate.setValue(this.data?.Data.service_date);
      if (this.data.Data.service_date)
      {
        this.serviceDate = this.data.Data.service_date;
      }
      this.physicianForm.controls.itemList.setValue(this.data.Data.mbs);
      this.physicianForm.controls.editing.setValue(this.data.Data.id);
      this.physicianForm.controls.submission_id.setValue(this.data.Data.id);
    };
  }

  async submit() {
    if (this.physicianForm.valid) {
      this.physicianForm.controls.referringProvider.setValue(
        this.physicianForm.controls.referringProviderF.value + " " + this.physicianForm.controls.referringProviderL.value
      );
      const alert = await this.alertController.create({
        cssClass: 'success_alert', 
        header: 'Please Confirm',
        mode:'ios',
        animated: true,
        message: ('Are you sure you want to submit billing for '+ this.data.Data.patient_first_name + ' ' + this.data.Data.patient_last_name)+' <br><br>Please be patient once you submit your billing.  During submission, your billing request information is collected before producing a reference number.  Please wait until you receive confirmation of a successful submission.',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'red',
            handler: (blah) => {
            }
          }, {
            text: 'Submit',
            cssClass: 'buttonUpdate',
            handler: () => {
              this.submitBilling();
            }
          } 
      
      ] });
      await alert.present();
    } else {
      // eslint-disable-next-line guard-for-in
      for (const property in this.physicianForm.value) {
        this.physicianForm.controls[property].markAsTouched();
      }
      this.physicianForm.markAsTouched();
    }
  }
  submitBilling() {
    const additionalArr = [];
    if (this.physicianForm.value.ionicSelect.length) {
      for (let i = 0; i < this.physicianForm.value.ionicSelect.length; i++) {
        //console.log(this.physicianForm.value.ionicSelect[i]);
        additionalArr.push(this.physicianForm.value.ionicSelect[i]);
      }
      this.physicianForm.controls.itemListAdditional.setValue(additionalArr);
    }
      this.disableButton = true;
      this.physicianForm.controls.User.setValue(this.user);
      this.physicianForm.controls.referralDate.setValue(
        moment(this.physicianForm.controls.referralDate.value).format(
          'YYYY-MM-DD'
        )
      );
      this.physicianForm.controls.serviceDate.setValue(
        moment(this.physicianForm.controls.serviceDate.value).format(
          'YYYY-MM-DD'
        )
      );
      delete this.physicianForm.value.ionicSelect;
      this.physicianForm.controls.version.setValue(this.thisVersion);
      let loading = null;
        this.loadingController.create({
          message: 'Please wait while we submit your billing.  Once successfully submitted, you will receive a submission and billing reference number.',
          spinner: "circles"
          // You can customize options here
        }).then((loadingInstance) => {
          loading = loadingInstance;
          loading.present();
        });
      this.apiService.post('data/another-billing', this.physicianForm.value).subscribe(
        (res) => {
          if (res.error === false) {
            //this.toastService.presentToast( 'success', 'Submitted Successfully' );
            // this.navCtrl.navigateRoot('/home');
            this.storageService.remove('state');
            let ref = 'Submission ID: ' + this.physicianForm.value['submission_id'];
            if (res.data.ref)
            {
              ref = 'Submission ID: ' + this.physicianForm.value['submission_id'] + '<br>Billing Ref: ' + res.data.ref;
            }
            loading.dismiss();
            this.presentSuccessfulSubmissionAlert('You have successfully submitted billing to Medbill. You will receive a confirmation email shortly.<br><br>' + ref);
                    
            if (this.patientType == 'patient') {
              this.router.navigateByUrl('/submission'); 

            } else {
              this.router.navigateByUrl('/ward-round'); 
            }
          }
          else
          {
            loading.dismiss();
            this.presentFailedSubmissionAlert('There was a problem with your submission:<br><br>'+res.error.message);
            this.router.navigateByUrl('/home');
          }
        },
        (err) => { 
          
          loading.dismiss();
          this.presentFailedSubmissionAlert('There was a problem with your submission.');
          this.router.navigateByUrl('/home');
        }
      );
  }

  async presentSuccessfulSubmissionAlert(alertmsg) {
    const alert = await this.alertController.create({
      cssClass: 'success_alert', 
      header: 'Submission Successful',
      message: alertmsg,
      buttons: ['OK'],
    });
    await alert.present();
  }

  async presentFailedSubmissionAlert(alertmsg) {
    const alert = await this.alertController.create({
      cssClass: 'fail_alert', 
      header: 'Submission Failed',
      message: alertmsg,
      buttons: ['OK'],
    });
    await alert.present();
  }

  selectSize(itemNumber: any, isChecked: any) {
    if (isChecked.detail.checked) {
      this.selectedArray.push(itemNumber);
    } else {
      const index = this.selectedArray.indexOf(itemNumber);
      this.selectedArray.splice(index, 1);
    }
    this.physicianForm.controls.itemList.setValue(this.selectedArray);

  }

  getHospitalList() {
    this.apiService.post('hospital-list', {}).subscribe(
      (res) => {
        if (res.error === false) {
          this.hospitalList = res.data.hospitals;
          this.physicianForm.controls.hospital.setValue(this.data.Data.hospital);
        }
      },
      (err) => { }
    );
  }


  discharge() {
    this.physicianForm.controls.wardRound.setValue(false);
  }

  presentModal() {
    this.modalController.create({
      component: DoctorsListComponent,
      // cssClass: 'billing-modal',
      showBackdrop: true,
      backdropDismiss: true,
    }).then(res => {
      res.present();
      res.onDidDismiss().then((doctor: any) => {
        if (doctor && doctor.data) {
          this.physicianForm.controls.referringProvider.setValue(doctor.data);
        }
      });
    });
  }

  getItems(args) {
    if (args && args.text) {
      const payload = {
        search: args.text,
      };
      this.apiService.post('data/check-item-exist', payload).subscribe(
        (res) => {
          if (res.error === false) {
            this.mbsValidateitems = res.data;
          }
        },
        (err) => {
        }
      );
    }
  }
  portChange(args) {
    if (args.value) {
      const additionalItem = args.value.map(e => Number(e.ItemNum));
      this.physicianForm.controls.itemListAdditional.setValue(additionalItem);
    }
  }
  openItemModal() {
    this.modalController.create({
      component: ItemListComponent,
      cssClass: 'items-modal',
      showBackdrop: true,
      backdropDismiss: true,
      componentProps: {
        selectedVal: this.physicianForm.value.ionicSelect,
      },
    }).then(res => {
      res.present();
      res.onDidDismiss().then((items: any) => {
        if (items && items.data) {
          this.ngZone.run(() => {
            const arr = [];
            for (let i = 0; i < items.data.length; i++) {
              arr.push(items.data[i]);
            }
            this.physicianForm.controls.ionicSelect.setValue(arr);
          });
        }
      });
    });
  }
  updateReferralDate($event) {
    this.referralDate = $event.detail.value;
    this.referralDateAccordion.value = undefined;
  }
  updateServiceDate($event) {
    this.serviceDate = $event.detail.value;
    this.serviceDateAccordion.value = undefined;
  }
  clearDoctor() {
    this.physicianForm.controls.referringProvider.setValue("");
  }
}
